import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Container = styled.div`
    padding: 1.5rem 2rem 3rem;
    color: var(--text-cor);

    input[type='checkbox'] {
        flex-shrink: 0;
        width: 1.6rem;
        height: 1.6rem;
        margin: 0;
        accent-color: var(--btn-admin-icone);
        cursor: pointer;

        &:disabled {
            cursor: not-allowed;
        }
    }
`;

export const Topo = styled.header`
    position: sticky;
    top: 0;
    z-index: 2;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1.2rem 2rem;
    margin-bottom: 3.6rem;
    padding: 1.6rem 2.4rem;
    border-radius: var(--def-radius);
    background: var(--white);
    box-shadow: 0 0.2rem 0.8rem rgba(32, 33, 36, 0.12);

    .titulo {
        flex: 1;
        min-width: 24rem;
    }

    h1 {
        margin: 0.4rem 0 0;
        font-size: var(--size-h4);
        font-weight: 600;
        color: var(--btn-admin-icone);
        overflow-wrap: anywhere;
    }

    p {
        margin: 0.4rem 0 0;
        font-size: var(--size-span);
        font-variant-numeric: tabular-nums;
    }

    .pendente {
        font-weight: 600;
        color: var(--btn-underline-cor);
    }

    input[type='search'] {
        height: 3.6rem;
        width: 24rem;
        padding: 0 1.2rem;
        border: 1px solid var(--bg-hover-light);
        border-radius: 0.6rem;
        font-size: var(--size-span);
        color: var(--text-cor);
        background: var(--white);

        &::placeholder {
            color: var(--gray);
        }

        &:focus-visible {
            outline: 2px solid var(--btn-admin-icone);
            outline-offset: 1px;
        }
    }

    .salvar {
        height: 3.6rem;
        padding: 0 2.4rem;
        border: 0;
        border-radius: 0.6rem;
        font-size: var(--size-span);
        font-weight: 600;
        cursor: pointer;
        color: var(--white);
        background: var(--btn-admin-icone);
        transition: background-color 0.15s ease-out;

        &:hover:not(:disabled) {
            background: var(--btn-underline-cor);
        }

        &:focus-visible {
            outline: 2px solid var(--btn-admin-icone);
            outline-offset: 2px;
        }

        &:disabled {
            cursor: not-allowed;
            color: var(--gray);
            background: var(--bg-hover-light);
        }
    }

    @media (max-width: 768px) {
        padding: 1.4rem 1.6rem;

        .titulo {
            flex-basis: 100%;
            min-width: 0;
        }

        h1 {
            font-size: 1.8rem;
        }

        input[type='search'] {
            flex: 1;
            width: auto;
            min-width: 0;
        }
    }
`;

export const Voltar = styled(Link)`
    display: inline-flex;
    align-items: center;
    gap: 0.6rem;
    font-size: 1.3rem;
    font-style: normal;
    text-decoration: none;
    color: var(--text-cor);

    &:hover {
        color: var(--btn-admin-icone);
    }

    &:focus-visible {
        outline: 2px solid var(--btn-admin-icone);
        outline-offset: 2px;
    }
`;

export const Grade = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(32rem, 1fr));
    align-items: start;
    gap: 1.6rem;

    @media (max-width: 560px) {
        grid-template-columns: 1fr;
    }
`;

export const Secao = styled.section`
    & + & {
        margin-top: 2.8rem;
    }

    h2 {
        display: inline-flex;
        align-items: baseline;
        gap: 0.8rem;
        margin: 0 0 1.2rem;
        padding: 0.6rem 1.2rem;
        border-radius: 0.6rem;
        background: var(--white);
        box-shadow: 0 0.1rem 0.3rem rgba(32, 33, 36, 0.08);
        font-size: 1.3rem;
        font-weight: 700;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: var(--btn-admin-icone);

        span {
            font-size: 1.2rem;
            font-weight: 600;
            letter-spacing: 0;
            font-variant-numeric: tabular-nums;
            color: var(--text-cor);
        }
    }
`;

export const Vazio = styled.p`
    padding: 4rem 0;
    text-align: center;
    font-size: var(--size-span);
`;

export const Card = styled.section`
    border: 1px solid var(--bg-hover-light);
    border-radius: var(--def-radius);
    background: var(--white);
    box-shadow: 0 0.1rem 0.3rem rgba(32, 33, 36, 0.08);

    header {
        display: flex;
        align-items: center;
        gap: 1rem;
        padding: 1.4rem 1.6rem 1.4rem 2rem;
    }

    .nome {
        flex: 1;
        min-width: 0;
    }

    h3,
    .unica strong {
        display: block;
        margin: 0;
        font-size: var(--size-p);
        font-weight: 600;
        color: var(--brown);
    }

    small {
        display: block;
        margin-top: 0.2rem;
        font-size: 1.2rem;
        color: var(--gray);
        overflow-wrap: anywhere;
    }

    .contagem {
        padding: 0.2rem 1rem;
        border-radius: 2rem;
        font-size: 1.2rem;
        font-weight: 600;
        font-variant-numeric: tabular-nums;
        white-space: nowrap;
        color: var(--text-cor);
        background: var(--bg-color);

        &.cheio {
            color: var(--btn-admin-icone);
            background: var(--btn-bg-small-interest);
        }
    }

    .colapsar {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 3.2rem;
        height: 3.2rem;
        padding: 0;
        border: 0;
        border-radius: 0.6rem;
        cursor: pointer;
        color: var(--text-cor);
        background: transparent;

        svg {
            transition: transform 0.2s ease-out;
        }

        &.fechado svg {
            transform: rotate(-90deg);
        }

        &:hover {
            background: var(--bg-color);
        }

        &:focus-visible {
            outline: 2px solid var(--btn-admin-icone);
        }
    }

    .corpo {
        padding: 1.2rem 2rem 1.6rem;
        border-top: 1px solid var(--bg-hover-light);
    }

    .marcar-todos {
        margin: 0 0 1rem;
        padding: 0;
        border: 0;
        font-size: 1.3rem;
        font-weight: 600;
        cursor: pointer;
        color: var(--btn-underline-cor);
        background: transparent;

        &:hover:not(:disabled) {
            text-decoration: underline;
            text-underline-offset: 0.3rem;
        }

        &:disabled {
            display: none;
        }
    }

    .acoes {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 0.4rem 2rem;
    }

    .acoes label {
        align-items: flex-start;
        padding: 0.6rem 0;
        line-height: 1.4;

        input {
            margin-top: 0.15em;
        }
    }

    label {
        display: flex;
        align-items: center;
        gap: 1rem;
        min-height: 3.2rem;
        font-size: var(--size-span);
        cursor: pointer;
    }

    label.unica {
        gap: 1.6rem;
        padding: 1.4rem 2rem;
        border-radius: var(--def-radius);

        &:hover {
            background: var(--bg-white);
        }

        &:focus-within {
            outline: 2px solid var(--btn-admin-icone);
            outline-offset: -2px;
        }
    }

    .acao-unica {
        display: inline-flex;
        align-items: center;
        gap: 0.8rem;
        white-space: nowrap;
    }
`;
